// داده‌های نمونه درخواست‌های احراز هویت کاربران
// در پروژه واقعی این داده‌ها باید از API دریافت شوند

export const STATUS = {
  NONE: 0,
  PENDING: 1,
  APPROVED: 2,
  REJECTED: 3,
};

export const statusLabels = {
  [STATUS.PENDING]: "در انتظار بررسی",
  [STATUS.APPROVED]: "تایید شده",
  [STATUS.REJECTED]: "رد شده",
};

const requests = [
  {
    id: 1,
    firstName: "علی",
    lastName: "محمدی",
    nationalCode: "0012345678",
    phone: "09123456789",
    requestDate: "1403/03/20",
    requestTime: "10:30",
    status: STATUS.PENDING,
    personalInfo: {
      firstName: "علی",
      lastName: "محمدی",
      nationalCode: "0012345678",
    },
    companyInfo: {
      jobTitle: "صاحب بار",
      companyName: "شرکت حمل و نقل پارس",
      nationalId: "14001234567",
      officePhone: "031-12345678",
      city: "اصفهان",
      officeAddress: "اصفهان، خیابان شیخ صدوقی، کوچه، پلاک ۳۴",
    },
    documents: {
      idCardImage: null,
      selfieImage: null,
    },
  },
  {
    id: 2,
    firstName: "سارا",
    lastName: "رضایی",
    nationalCode: "0023456789",
    phone: "09129876543",
    requestDate: "1403/03/19",
    requestTime: "14:15",
    status: STATUS.APPROVED,
    personalInfo: {
      firstName: "سارا",
      lastName: "رضایی",
      nationalCode: "0023456789",
    },
    companyInfo: {
      jobTitle: "کارشناس فروش",
      companyName: "شرکت بازرگانی البرز",
      nationalId: "14002345678",
      officePhone: "021-22334455",
      city: "تهران",
      officeAddress: "تهران، خیابان ولیعصر، پلاک ۱۲",
    },
    documents: {
      idCardImage: null,
      selfieImage: null,
    },
  },
  {
    id: 3,
    firstName: "محمد",
    lastName: "حسینی",
    nationalCode: "0034567890",
    phone: "09125556677",
    requestDate: "1403/03/18",
    requestTime: "09:20",
    status: STATUS.REJECTED,
    personalInfo: {
      firstName: "محمد",
      lastName: "حسینی",
      nationalCode: "0034567890",
    },
    companyInfo: {
      jobTitle: "راننده",
      companyName: "شرکت باربری کاوه",
      nationalId: "14003456789",
      officePhone: "031-98765432",
      city: "اصفهان",
      officeAddress: "اصفهان، بلوار کشاورز، پلاک ۵",
    },
    documents: {
      idCardImage: null,
      selfieImage: null,
    },
  },
  {
    id: 4,
    firstName: "فاطمه",
    lastName: "موسوی",
    nationalCode: "0045678901",
    phone: "09331234567",
    requestDate: "1403/03/17",
    requestTime: "16:45",
    status: STATUS.PENDING,
    personalInfo: {
      firstName: "فاطمه",
      lastName: "موسوی",
      nationalCode: "0045678901",
    },
    companyInfo: {
      jobTitle: "مدیر دفتر",
      companyName: "شرکت حمل و نقل نور",
      nationalId: "14004567890",
      officePhone: "071-33445566",
      city: "شیراز",
      officeAddress: "شیراز، خیابان زند، پلاک ۲۰",
    },
    documents: {
      idCardImage: null,
      selfieImage: null,
    },
  },
  {
    id: 5,
    firstName: "حسین",
    lastName: "احمدی",
    nationalCode: "0056789012",
    phone: "09127778899",
    requestDate: "1403/03/16",
    requestTime: "11:05",
    status: STATUS.APPROVED,
    personalInfo: {
      firstName: "حسین",
      lastName: "احمدی",
      nationalCode: "0056789012",
    },
    companyInfo: {
      jobTitle: "صاحب بار",
      companyName: "شرکت حمل و نقل رهرو",
      nationalId: "14005678901",
      officePhone: "031-11223344",
      city: "اصفهان",
      officeAddress: "اصفهان، خیابان چهارباغ، پلاک ۸",
    },
    documents: {
      idCardImage: null,
      selfieImage: null,
    },
  },
];

export default requests;
